import React from "react";
import {
  Box,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  InputAdornment,
  SelectChangeEvent,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

interface FilterBarProps {
  searchQuery: string;
  onSearchChange: (value: string) => void;
  statusFilter: string;
  onStatusChange: (value: string) => void;
  severityFilter: string;
  onSeverityChange: (value: string) => void;
  sortBy: string;
  onSortChange: (value: string) => void;
}

const FilterBar: React.FC<FilterBarProps> = ({
  searchQuery,
  onSearchChange,
  statusFilter,
  onStatusChange,
  severityFilter,
  onSeverityChange,
  sortBy,
  onSortChange,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        gap: 2,
        mb: 3,
        flexWrap: "wrap",
        alignItems: "center",
      }}
    >
      <TextField
        placeholder="Search incidents..."
        value={searchQuery}
        onChange={(e) => onSearchChange(e.target.value)}
        size="small"
        sx={{
          flex: "1 1 250px",
          minWidth: "200px",
          "& .MuiOutlinedInput-root": {
            backgroundColor: "white",
          },
        }}
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ color: "text.secondary", fontSize: 20 }} />
              </InputAdornment>
            ),
          },
        }}
      />

      <FormControl size="small" sx={{ minWidth: 150 }}>
        <InputLabel data-testid="status-label">Status</InputLabel>
        <Select
          value={statusFilter}
          label="Status"
          onChange={(e: SelectChangeEvent) => onStatusChange(e.target.value)}
          sx={{ backgroundColor: "white" }}
        >
          <MenuItem value="all">All</MenuItem>
          <MenuItem value="active">Active</MenuItem>
          <MenuItem value="resolved">Resolved</MenuItem>
        </Select>
      </FormControl>

      <FormControl size="small" sx={{ minWidth: 150 }}>
        <InputLabel>Severity</InputLabel>
        <Select
          value={severityFilter}
          label="Severity"
          onChange={(e: SelectChangeEvent) => onSeverityChange(e.target.value)}
          sx={{ backgroundColor: "white" }}
        >
          <MenuItem value="all">All</MenuItem>
          <MenuItem value="critical">Critical</MenuItem>
          <MenuItem value="warning">Warning</MenuItem>
        </Select>
      </FormControl>

      <FormControl size="small" sx={{ minWidth: 150, ml: "auto" }}>
        <InputLabel>Sort</InputLabel>
        <Select
          value={sortBy}
          label="Sort"
          onChange={(e: SelectChangeEvent) => onSortChange(e.target.value)}
          sx={{ backgroundColor: "white" }}
        >
          <MenuItem value="oldest">Oldest first</MenuItem>
          <MenuItem value="newest">Newest first</MenuItem>
          <MenuItem value="severity">Severity</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
};

export default FilterBar;
